import { aboutUsData, PageType } from "@/types/cms.types";
import baseApi from "./RootBaseApi";

export const CmsService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPage: builder.query({
      query: ({ pageType }: { pageType: PageType; language: string }) => ({
        url: `/cms/${pageType}`,
        method: "GET",
      }),
      providesTags: ["CMS"],
      keepUnusedDataFor: 0,
    }),
    createPage: builder.mutation({
      query: (body) => ({
        url: "/cms",
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["CMS"],
    }),
    updateContent: builder.mutation({
      query: ({ pageId, contentId, body }) => ({
        url: `/cms/${pageId}/contents/${contentId}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: ["CMS"],
    }),
    deleteContent: builder.mutation({
      query: ({ pageId, contentId }) => ({
        url: `/cms/${pageId}/contents/${contentId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CMS"],
    }),
    updateAboutUsContent: builder.mutation({
      query: ({
        pageId,
        body,
      }: {
        pageId: string;
        body: aboutUsData;
        language: string;
      }) => ({
        url: `/cms/${pageId}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: ["CMS"],
    }),
    updatePage: builder.mutation({
      query: ({
        pageId,
        body,
      }: {
        pageId: string;
        body: { legal_effective_from?: string; status?: "draft" | "published" };
      }) => ({
        url: `/cms/${pageId}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: ["CMS"],
    }),
  }),
});

export const {
  useGetPageQuery,
  useCreatePageMutation,
  useUpdateContentMutation,
  useDeleteContentMutation,
  useUpdateAboutUsContentMutation,
  useUpdatePageMutation,
} = CmsService;
